<template>
  <WfPayloadTooLargeErrorButton v-if="errorCode === 413 || errorCode === 406" />
  <WfSignOutErrorButton v-else-if="signOutErrors.includes(errorCode)" />
  <button
    v-else
    class="wf-main-button wf-main-button--secondary"
    @click="handleErrorBackButtonClick"
  >
    <WfIcon icon="back-arrow" />
    Back
  </button>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

import WfIcon from '@/components/WfIcon.vue';
import WfSignOutErrorButton from './WfSignOutErrorButton.vue';
import WfPayloadTooLargeErrorButton from './WfPayloadTooLargeErrorButton.vue';
export default {
  components: {
    WfIcon,
    WfSignOutErrorButton,
    WfPayloadTooLargeErrorButton,
  },
  computed: {
    ...mapGetters(['errorCode']),
    signOutErrors() {
      return [400, 401, 403, 404];
    },
  },
  methods: {
    ...mapMutations(['setErrorObject']),
    handleErrorBackButtonClick() {
      this.setErrorObject({
        show: false,
        code: null,
        error: null,
      });
    },
  },
};
</script>
